import styled from 'styled-components'
import policyDocsImage3 from '../../../images/policy-confirmation-docs-3.png'
import policyConfirmationQRCode from '../../../images/policy-confirmation-qr-code.png'
import { Card } from 'components/@common/Card'

export const PolicyDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 10px;
`

export const PolicyDocumentsList = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: 1fr;
  padding: 0;
  margin: 0;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const PolicyDocumentListItem = styled.li`
  display: flex;
  flex: 1;
  width: 100%;
`

export const PolicyDocumentLink = styled.a`
  cursor: pointer;
  align-items: center;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  padding: 8px;
  color: ${(props) => props.theme.primaryTextColour};
  font-family: ${(props) => props.theme.button.fontFamily};
  font-size: 16px;
  line-height: 20px;
  width: 100%;
`

export const PolicyDocumentName = styled.span`
  display: inline-block;
  margin-left: 8px;
  text-align: left;
`

export const MobileAppBannerMobile = styled(Card)`
  display: none;
  background-color: white;
  border: 2px solid #fe5000;
  padding: 10px 15px 0;
  overflow: hidden;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    padding: 15px 15px 0;
  }
`
export const PolicyLogoContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin-right: 10px;
`

export const MobileBannerContent = styled.div`
  display: flex;
  gap: 15px;
  align-items: stretch;
  width: 100%;

  & > div:first-child {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`

export const ImageContainer = styled.div`
  flex-shrink: 0;
  width: 92px;
  display: flex;
  align-items: flex-end;
`

export const MobileAppBannerMobileText = styled.p`
  color: #38363d;
  font-size: 16px;
  font-weight: normal;
  margin: 0;
  line-height: 1.4;
  flex: 1;
  padding-bottom: 10px;
  align-items: center;
`

export const MobileAppBannerMobileImage = styled.div`
  height: 133px;
  width: 92px;
  background-image: url(${policyDocsImage3});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`

export const MobileAppBannerDesktop = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  border: 2px solid #fe5000;
  padding: 0 15px;
  border-radius: 10px;
  gap: 15px;
  margin-top: 50px;
  // overflow: hidden;

  @media (max-width: 768px) {
    display: none;
  }
`

export const MobileAppBannerDesktopText = styled.p`
  color: #38363d;
  font-size: 16px;
  font-weight: normal;
  margin: 0;
  line-height: 1.4;
  flex: 1;
`

export const MobileAppBannerDesktopQRCode = styled.div`
  background-image: url(${policyConfirmationQRCode});
  background-repeat: no-repeat;
  background-size: contain;
  height: 57px;
  width: 57px;
  border: 2px solid #fe5000;
  border-radius: 4px;
  flex-shrink: 0;
`

export const MobileAppBannerDesktopImage = styled.div`
  width: 92px;
  height: 133px;
  margin-top: -40px;
  flex-shrink: 0;
  background-image: url(${policyDocsImage3});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`
